import type { ShotLeftPanelKey } from "@/components/shot-modal-sidebar"
import type { ShotViewMode } from "@/stores/shot-panel-store"

export type ShotLeftColumnId =
  | "composer"
  | "flow-side"
  | "characters"
  | "location"
  | "props"
  | "storyboard_versions"
  | "shooting_board_versions"
  | "video_versions"
  | "post_production_versions"

export type ShotRightColumnId = "preview" | "flow"

export type ShotPanelColumns = {
  left: ShotLeftColumnId
  right: ShotRightColumnId
}

const ENTITY_LEFT = new Set<ShotLeftColumnId>([
  "characters",
  "location",
  "props",
  "storyboard_versions",
  "shooting_board_versions",
  "video_versions",
  "post_production_versions",
])

function entityLeft(panel: ShotLeftPanelKey): ShotLeftColumnId | null {
  if (panel === "prompt" || panel === "assistant" || panel === "flow") return null
  return ENTITY_LEFT.has(panel) ? panel : null
}

/** What each column shows for a mode and left panel. Home is prompts or the flow side. */
export function shotPanelColumns(
  mode: ShotViewMode,
  leftIsHome: boolean,
  leftPanel: ShotLeftPanelKey,
): ShotPanelColumns {
  const right: ShotRightColumnId = mode === "flow" ? "flow" : "preview"
  if (leftIsHome) return { left: mode === "flow" ? "flow-side" : "composer", right }
  return { left: entityLeft(leftPanel) ?? (mode === "flow" ? "flow-side" : "composer"), right }
}

/** Entity screens fetch on mount, so the incoming one stays hidden until that fetch settles. */
export function preloadsLeftColumn(id: ShotLeftColumnId): boolean {
  return id !== "composer" && id !== "flow-side"
}
